import styled, { css } from 'styled-components';
import { Headline } from 'ggApp/shared/common/Typography';
import { ItemCard } from 'ggApp/shared/components/Cart/ItemCard';
import { InfoCard } from 'ggApp/modules/newCheckout/components/InfoCard';
import Circle from 'ggApp/shared/components/CircleLoader';
import VoucherCard from 'ggApp/modules/newCheckout/components/VoucherCard';
import { UnavailableCard } from 'ggApp/modules/newCheckout/components/UnavailableCard';
import InfoIcon from 'ggApp/shared/icons/InfoOutline';

import SummaryBlock from './CtaBlock';

export const Container = styled.section`
    height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar { display: none; width:  0 !important; }
`;

export const Header = styled(Headline)`
    ${(props) => props.theme.typography.Subheadline};
    order: ${({ titleOrder }) => titleOrder};

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 8px 0;
    `};
`;

export const WidgetContainer = styled.div`
    display: grid;
    margin-top: 16px;
    grid-template-areas: ${({ orderMode }) =>
        orderMode === 'MIX' ? "'items user' 'order user'" : "'order user'"};
    grid-template-columns: minmax(50%, 1fr) 1fr;
    grid-gap: 0 24px;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        flex-direction: column;
        display: ${({ orderMode }) => (orderMode === 'FLEX' ? 'flex' : 'grid')};
        grid-template-areas: 'items' 'user' 'order';
        grid-template-columns: 1fr;
    `};
`;

export const MixItemsWrap = styled.div`
    grid-area: items;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-bottom: 8px;
    `};
`;

export const ItemsContainer = styled.div`
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        order: 4;
    `};
`;

export const CartItem = styled(ItemCard)`
    &:not(:first-child) {
        margin-top: 8px;
    }
`;

export const OrderInformation = styled.div`
    grid-area: order;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        order: 2;
    `};
`;

export const UserInformation = styled.div`
    grid-area: user;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        display: flex;
        flex-direction: column;
    `};
`;

export const SummaryNote = styled.div`
    ${({ theme }) => theme.typography.TinyParagraph};
    margin-top: 16px;
    color: ${({ theme }) => theme.colors['Level 5']};

    & > span > a {
        color: ${({ theme }) => theme.colors['Level 5']};
        text-decoration: underline;

        &:hover {
            color: unset;
        }
    }
`;

export const Summary = styled(SummaryBlock)`
    padding-top: 8px;
`;

export const SummaryWrapper = styled.div`
    margin-top: 24px;
    padding-top: 8px;
    border-top: 2px solid ${({ theme }) => theme.colors['Level 1']};
`;

export const ButtonWrap = styled.div`
    position: relative;
`;

export const Cards = styled.div`
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        order: 3;
        margin-bottom: 8px;
    `};
`;

export const Card = styled(InfoCard)`
    &:not(:first-child) {
        margin-top: 8px;
    }
`;

export const Voucher = styled(VoucherCard)`
    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        order: 1;
    `};
`;

export const MobileImp = styled.div`
    order: 2;
    margin: 8px 0 24px;
`;

export const CircleLoader = styled(Circle)`
    position: absolute;
    width: unset;
    height: unset;
    top: 0;
    left: calc(50% - 22px);
`;

export const UnavailableProduct = styled(UnavailableCard)`
    &:not(:first-child) {
        margin-top: 8px;
    }
`;

export const Icon = styled(InfoIcon)`
    width: 16px;
    height: 16px;
    margin-left: 4px;
`;

export const IconWrapper = styled.span`
    :focus {
        outline: none;
    }
`;

export const ConsentNote = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
    padding: 16px;
    background-color: rgba(255, 199, 0, 0.1);
    border-radius: 8px;

    ${(props) => css(props.theme.typography.TinyParagraph)};
    color:  ${({ theme }) => theme.colors['Level 5']};

    a {
        color:  ${({ theme }) => theme.colors['Level 5']};
        text-decoration: underline;
    }
`;
